export default __webpack_public_path__ + "static/media/logo.06f27d61.jpg";